import React from 'react';
import HeaderDNW from '../headerDNW';
import GNHeader from '../GN/gnHeader';
import { isExternalFlow } from '../../utility/externalIntegrationUtils';

const DonateHeader = () => {
  return <div>{isExternalFlow() ? <GNHeader /> : <HeaderDNW />}</div>;
};

export default DonateHeader;
